import React from 'react';
import InvoiceView from '../components/InvoiceView';
import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

const InvoicePage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hashId = queryParams.get('hash');
  const skipTracking = queryParams.get('skipTracking') === 'true';

  if (!hashId) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <h2>Invoice hash not provided</h2>
        <p>Please specify a valid invoice hash to view the invoice.</p>
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 0, md: 3 } }}>
      <InvoiceView hashId={hashId} skipTracking={skipTracking} />
    </Box>
  );
};

export default InvoicePage;